import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsGrid() {
  const featured = testimonials.find(t => t.featured) ?? testimonials[0];
  const rest = testimonials.filter(t => t !== featured);
  return <section className="border-b border-line bg-night py-20 sm:py-24" data-id="element-248" data-mp="1e5j5tvehgqlg">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-249" data-mp="1e5ask2eg7j9q">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-250" data-mp="196pqryjjsrj6">
          <div className="max-w-2xl" data-id="element-251" data-mp="14fragyyk7tfx">
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-252" data-mp="14eohmlhofgxd">
              Trusted by academies worldwide
            </p>
            <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-253" data-mp="10bry8skbbgsd">
              What directors are saying
            </h2>
          </div>
          <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-white/50" data-id="element-254" data-mp="lgvfhlevnb11">
            <StarIcon className="h-4 w-4 fill-acid text-acid" aria-hidden="true" data-id="element-255" data-mp="1elo9qwqe8eq6" />
            4.9/5 · 1,200+ coaches
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-3" data-id="element-256" data-mp="14n8jsx33rbi9">
          <figure className="flex flex-col justify-between border border-acid/40 bg-panel p-8 lg:row-span-2 lg:p-10" data-id="element-257" data-mp="14orzalgxpiiz">
            <blockquote className="font-display text-2xl font-bold uppercase leading-tight tracking-tight text-white sm:text-3xl" data-id="element-258" data-mp="19k7bl8zan6da">
              &ldquo;{featured.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-10 flex items-center gap-4" data-id="element-259" data-mp="228wdvbc35hqm">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center bg-acid font-display text-base font-bold text-night" data-id="element-260" data-mp="1ncwzjiyduld1">
                {featured.initials}
              </span>
              <span className="text-xs uppercase tracking-[0.14em] text-white/50" data-id="element-261" data-mp="bxi5oo1h09m5">
                <span className="block font-semibold text-white" data-id="element-262" data-mp="gxwalx7rz3fy">
                  {featured.name}
                </span>
                {featured.role}
              </span>
            </figcaption>
          </figure>

          {rest.map(item => <figure key={item.name} className="flex flex-col justify-between border border-line bg-panel p-7" data-id="element-263" data-mp="2enb7lyycin1n">
              <blockquote className="text-sm leading-relaxed text-white/65" data-id="element-264" data-mp="24udmrm5vslzv">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3" data-id="element-265" data-mp="1zu7srzc52nem">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center border border-line font-display text-sm font-bold text-acid" data-id="element-266" data-mp="1vtxhq89hp6sw">
                  {item.initials}
                </span>
                <span className="text-[11px] uppercase tracking-[0.14em] text-white/45" data-id="element-267" data-mp="1ly3yy756gh2o">
                  <span className="block font-semibold text-white/85" data-id="element-268" data-mp="3l8c6utof6vox">
                    {item.name}
                  </span>
                  {item.role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}